import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locales/en.json";
import { SUPPORTED_LOCALES } from "./utils/locales";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: { en },
});

const loadedLocales = new Set(["en"]);
const pendingLoads = new Map();

// Tracks the most recently requested locale so that a slow, superseded
// load can't clobber i18n.locale after a faster later request already won.
let latestRequestedLocale = "en";

export async function loadLocale(locale) {
  const nextLocale = SUPPORTED_LOCALES.includes(locale) ? locale : "en";
  latestRequestedLocale = nextLocale;

  if (!loadedLocales.has(nextLocale)) {
    if (!pendingLoads.has(nextLocale)) {
      pendingLoads.set(
        nextLocale,
        import(
          /* webpackChunkName: "locale-[request]" */
          `./locales/${nextLocale}.json`
        )
          .then(messages => {
            i18n.setLocaleMessage(nextLocale, messages.default || messages);
            loadedLocales.add(nextLocale);
          })
          .finally(() => {
            pendingLoads.delete(nextLocale);
          })
      );
    }

    await pendingLoads.get(nextLocale);
  }

  if (latestRequestedLocale === nextLocale) {
    i18n.locale = nextLocale;
  }

  return nextLocale;
}

export default i18n;
